@import '../../../scss/mixins';

:host {
  display: block;
  width: 100%;
  line-height: 1;
}

.spw-card-image {
  position: relative;
  overflow: hidden;
  border-radius: 5px 5px 0 0;

  ::slotted(img),
  img {
    width: 100%;
    height: auto;
    transition: all 0.3s ease;
    transform-origin: center center;
  }

  &__icon {
    &:before {
      @include blanket;
      background: var(--spw-ds-primary);
      opacity: 0.4;
    }
    position: absolute;
    z-index: 2;
    display: flex;
    visibility: hidden;
    width: 100%;
    height: 100%;
    font-size: 30px;
    font-weight: 300;
    opacity: 0;
    top: 0;
    left: 0;
    color: white;
    justify-content: center;
    align-items: center;
    transition: all 0.3s ease;

    spw-icon {
      transform: scale(1.5);
      transition: all 0.3s ease;
    }
  }

  &__label {
    position: absolute;
    top: 10px;
    right: 10px;
    display: inline-flex;
    padding: 8px 12px;
    align-items: center;
    border-radius: 9999px;
    color: var(--spw-color-themes-grey-grey-900);
    box-shadow: var(--spw-effect-elevation-3);
    font-size: 14px;
    background: var(--spw-ds-white);
    z-index: 3;
  }
}

:host(.--hovered) {
  .spw-card-image,
  .spw-card-image.--is-hovered {
    .spw-card-image__icon {
      visibility: visible;
      opacity: 1;
      spw-icon {
        transform: scale(1);
      }
    }
    ::slotted(img) {
      transform: scale(1.1);
    }
  }
}
